var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-col',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"span":12}},[_c('div',{ref:"wrap",staticClass:"box"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }